export default {

    title: 'Maßnahmen',
    freetext: 'Freitext',
    process_number: 'Ordnungsnummer',
    year: 'Jahr',
    status: 'Status', // old filter name, might be stored in someone's localstorage
    statusKey: 'Status',
    id: 'ID',
    event: 'Maßnahme',
    organisation: 'Organisation',
    fundingProgram: 'Förderprogramm',
    funding_program: 'Förderprogramm',
    partner_country: 'Partnerland',
    multiplePartners: 'Multilateral',
    country: 'Land',
    period: 'Von - Bis',
    formProcesses: 'Formulare',
    subsidy_amount: 'Zuschusshöhe',
    customFilterHasOpenPayment: 'Offene Zahlungen',
    symbols: 'Infos mobil', // header for mobile column

    qf_ownOnly: 'Nur eigene Maßnahmen'
}